import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Col, Container, Row } from 'react-bootstrap';
import moment from 'moment';
import { Breadcrumbs, Date, PageBody, PageHeader, PageTitle, Section } from 'modules';
import ContractFiles from './components/ContractFiles';
import ContractSignatureInfo from 'components/ContractSignatureInfo/ContractSignatureInfo';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import {
  selectConsultantAccess,
  selectMeetingModeOnline,
  selectOnlineForm,
  selectOnlineFormContract,
  selectOnlineFormData,
} from 'stores/onlineForm/onlineForm';
import ButtonAcceptToSignReport from 'components/ButtonAcceptToSignReport/ButtonAcceptToSignReport';
import { bonatoCompany } from 'constants/company';

const OnlineFormTransmitReport = () => {
  const { t } = useTranslation();
  const wsContext = useContext(WebsocketContext);

  const form = useSelector(selectOnlineForm);
  const formData = useSelector(selectOnlineFormData);
  const contract = useSelector(selectOnlineFormContract);
  const isConsultantAccess = useSelector(selectConsultantAccess);
  const isOnlineMode = useSelector(selectMeetingModeOnline);

  const onSubmitSign = () => {
    // požadavek na aktualizaci
    wsContext?.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
  };

  return (
    <>
      <PageHeader>
        <Breadcrumbs>
          <Breadcrumbs.Item to="/" active={false}>
            <Trans>ONLINE_FORMS.TRANSMIT_REPORT</Trans>
          </Breadcrumbs.Item>
        </Breadcrumbs>
      </PageHeader>

      <Container className="m-0">
        <PageTitle title={t('ONLINE_FORMS.TRANSMIT_REPORT')} />

        <PageBody className="mt-2" style={{ maxWidth: 800 }}>
          <Section className="mb-3" style={{ color: 'black' }}>
            <div className="mb-3 text-center">
              <strong>ODOVZDÁVACÍ A PREBARACÍ PROTOKOL</strong>
              <br />
              <strong>
                k objednávke č. {contract?.cislo} podľa Objednávkového formulára zo dňa{' '}
                {moment(contract?.datum).format('D.M.Y')}
              </strong>
            </div>

            <div className="mb-4">
              <Row>
                <Col>
                  Na základe Objednávkového formulára zo dňa {moment(contract?.datum).format('D.M.Y')} (t.j. objednávka
                  č. {contract?.cislo}), dochádza dňa {moment(contract?.datum).format('D.M.Y')} medzi obchodnou
                  spoločnosťou:
                  <br />
                  {bonatoCompany.name} (dodávateľ) a {contract?.prijmeni} {contract?.jmeno} (objednávateľ) k odovzdaniu
                  predmetu objednávky v plnom rozsahu podľa dohodnutých podmienok.
                </Col>
              </Row>
            </div>

            {form?.reportSignIn && (
              <div className="mb-4">
                <strong>Zoznam dokumentov</strong>
                {contract && <ContractFiles form={form} contract={contract} />}
              </div>
            )}

            <div className="mb-1">
              <Row>
                <Col sm={7}>
                  V {contract?.spravaDluhu?.misto || 'Žiline'}, dňa <Date value={contract?.datum} />
                  <br />
                  <br />
                  {bonatoCompany.name}
                  <br />
                  {contract?.consultant3 && (
                    <>
                      {contract?.consultant3.prijmeni} {contract?.consultant3.jmeno}
                      <br />
                    </>
                  )}
                  Špecialista Oddlženia BONATO
                  <br />
                  na základe plnej moci
                  <br />
                </Col>
                <Col sm={5}>{form && form.reportSignIn !== null && <ContractSignatureInfo form={form} />}</Col>
              </Row>
            </div>
          </Section>
          <Row>
            <Col className="text-right">
              {form && form.reportSignIn === null && (
                <ButtonAcceptToSignReport
                  data={{
                    form: { id: form.id },
                    mobil: formData?.mobil || '',
                  }}
                  disabled={isConsultantAccess && isOnlineMode}
                  onSubmit={onSubmitSign}
                />
              )}
              {form && form.reportSignIn !== null && (
                <Button variant={'secondary'} className="ml-1" disabled={true}>
                  Odovzdanie posudku už bolo podpísaná
                </Button>
              )}
            </Col>
          </Row>
        </PageBody>
      </Container>
    </>
  );
};

export default OnlineFormTransmitReport;
